import React, { useCallback } from "react";

export const GameStatus = ({ label, value }) => <div className="game-stat"><span>{label}</span><strong>{value}</strong></div>;

export const GameOverlay = ({ title, copy, action, onAction }) => <div className="game-overlay">
  <h3>{title}</h3>
  <p>{copy}</p>
  <button className="button" type="button" onClick={onAction}>{action}</button>
</div>;

export const useFinish = (onFinish) => useCallback(
  (status, score) => onFinish({ status, score }),
  [onFinish]
);

export const seededShuffle = (items, seed = 1) => [...items]
  .map((value, index) => ({ value, rank: ((index + 1) * 9301 + seed * 49297) % 233280 }))
  .sort((a, b) => a.rank - b.rank)
  .map(({ value }) => value);

export const setCanvasSize = (canvas, width, height) => {
  const ratio = Math.min(window.devicePixelRatio || 1, 2);
  canvas.width = width * ratio;
  canvas.height = height * ratio;
  const context = canvas.getContext("2d");
  context.setTransform(ratio, 0, 0, ratio, 0, 0);
  return context;
};

